import { PRIMARY, UTILITY1, TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { safetyMargins, FULL_HD, HD } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../tornado/utils/style';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  background: makeThemeColor(TERTIARY),
  title: makeThemeColor(PRIMARY),
  exception: makeThemeColor(UTILITY1),
};

export const CONTENT_MARGIN_TOP = {
  [HD]: 144,
  [FULL_HD]: 264,
};
export const CONTENT_MARGIN_LEFT = {
  [HD]: 422,
  [FULL_HD]: 715,
};
export const CONTENT_WIDTH = {
  [HD]: 436,
  [FULL_HD]: 491,
};
export const CONTENT_HEIGHT = {
  [HD]: 451,
  [FULL_HD]: 549,
};

export const getContentSettings = screenSize => ({
  w: CONTENT_WIDTH[screenSize],
  h: CONTENT_HEIGHT[screenSize],
  y: CONTENT_MARGIN_TOP[screenSize],
  x: CONTENT_MARGIN_LEFT[screenSize],
  flex: { direction: 'column', alignItems: 'center' },
});

export const TITLE_HEIGHT = {
  [HD]: 72,
  [FULL_HD]: 96,
};

export const TITLE_WIDTH = {
  [HD]: 436,
  [FULL_HD]: 491,
};

export const BUTTON_OFFSET_LEFT = {
  [HD]: 20,
  [FULL_HD]: 70,
};

export const EXCEPTION_HEIGHT = {
  [HD]: 24,
  [FULL_HD]: 30,
};

export const getTitleSettings = (screenSize, colorMode) => ({
  text: {
    ...getFont(FONT.KINSHASA_2, screenSize),
    maxLines: 2,
    maxLinesSuffix: '...',
    wordWrapWidth: TITLE_WIDTH[screenSize],
    textAlign: 'center',
    textColor: colors.title[colorMode],
  },
});

export const PASSWORD_OFFSET_TOP = 32;
export const EXCEPTION_OFFSET = 12;

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => ({
  zIndex: 1,
  Background: {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    color: colors.background[colorMode],
    alpha: 0.9,
  },
  Button: {
    x: safetyMargins.horizontal[screenSize],
    y: safetyMargins.vertical[screenSize],
  },
  Content: {
    ...getContentSettings(screenSize),
    Title: {
      ...getTitleSettings(screenSize, colorMode),
    },
    PasswordBlock: {
      flexItem: { marginTop: PASSWORD_OFFSET_TOP },
    },
    Exception: {
      flexItem: { marginTop: EXCEPTION_OFFSET },
      h: EXCEPTION_HEIGHT[screenSize],
      alpha: 0,
      text: {
        ...getFont(FONT.BERLIN_1, screenSize),
        textColor: colors.exception[colorMode],
        verticalAlign: 'middle',
      },
    },
    Keyboard: {
      flexItem: { marginTop: EXCEPTION_OFFSET },
    },
  },
});
